import createTypes from 'redux-create-action-types';

export const asyncActionTypeRequest = (baseAction) => `${baseAction}_REQUEST`;
export const asyncActionTypeSuccess = (baseAction) => `${baseAction}_SUCCESS`;
export const asyncActionTypeFailure = (baseAction) => `${baseAction}_FAILURE`;

export default createTypes(
  'GET_SUPPLIERS',
  'GET_PRODUCT_CATEGORIES',
  'GET_FACTORY_LIST',
  'GET_BUYER_LIST',
  'ADD_PRODUCT',
  'UPDATE_PRODUCT',
  'CREATE_SUPPLIER',
  'UPDATE_SUPPLIER',
  'GET_COUNTRY_LIST',
);
